import { render, staticRenderFns } from "./EkrmShapeMonths.vue?vue&type=template&id=352ea7c4&scoped=true&"
import script from "./EkrmShapeMonths.vue?vue&type=script&lang=js&"
export * from "./EkrmShapeMonths.vue?vue&type=script&lang=js&"
import style0 from "./EkrmShapeMonths.vue?vue&type=style&index=0&id=352ea7c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ea7c4",
  null
  
)

export default component.exports